module.exports = __webpack_public_path__ + "static/media/lease5_img1.30f21881.jpg";